<div class="accordion-block clearfix">
  <ng-content></ng-content>
</div>
